<template>
  <div>
    <app-header />
    <product1 v-if="id == 1" />
    <product2 v-else-if="id == 2" />
    <product3 v-else-if="id == 3" />
    <product-home v-else />
    <app-footer />
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import Product1 from "@/components/product/Product73.vue";
import Product2 from "@/components/product/Product100.vue";
import Product3 from "@/components/product/Product113.vue";
import ProductHome from "@/components/product/ProductHome.vue";

export default {
  data() {
    return {
      id: this.$route.params.id
    };
  },
  created() {
    
  },
  mounted() {},
  methods: {

  },
  components: {
    AppHeader,
    AppFooter,
    Product1,
    Product2,
    Product3,
    ProductHome,
  }
};
</script>
<style lang="scss">
@import "@/assets/styles/scss/product.scss";
</style>



// WEBPACK FOOTER //
// src/pages/product/Product.vue